(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/spelpaus/assets/javascripts/collections/suspensions.js') >= 0) return;  svs.modules.push('/modules/spelpaus/assets/javascripts/collections/suspensions.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.spelpaus.collections.Suspensions = Backbone.Collection.extend({
    model: svs.spelpaus.models.Suspension
  });
})(Backbone, _, svs);

 })(window);